import { del, entries, get, set } from 'idb-keyval';
const ENCRYPTED_VALUE_MARKER = '__pplx_encrypted_query_cache_v1__';
const storeMigrations = new Map();
export async function setEncryptedQueryCacheValue(key, value, store) {
    const encryption = indexedDbEncryptionBridge();
    if (!encryption) {
        await set(key, value, store);
        return;
    }
    await ensureStoreIsEncrypted(store, encryption);
    await encryptAndSet(key, value, store, encryption);
}
export async function getEncryptedQueryCacheValue(key, store) {
    const encryption = indexedDbEncryptionBridge();
    if (encryption) {
        await ensureStoreIsEncrypted(store, encryption);
    }
    const storedValue = await get(key, store);
    if (!isEncryptedQueryCacheValue(storedValue)) {
        return storedValue;
    }
    if (!encryption) {
        throw new Error('IndexedDB encryption bridge is unavailable');
    }
    try {
        return await encryption.decrypt(storedValue[ENCRYPTED_VALUE_MARKER]);
    }
    catch (error) {
        await del(key, store);
        throw error;
    }
}
function ensureStoreIsEncrypted(store, encryption) {
    const existingMigration = storeMigrations.get(store);
    if (existingMigration)
        return existingMigration;
    const migration = migratePlaintextValues(store, encryption).catch((error) => {
        storeMigrations.delete(store);
        throw error;
    });
    storeMigrations.set(store, migration);
    return migration;
}
async function migratePlaintextValues(store, encryption) {
    const storedEntries = await entries(store);
    await Promise.all(storedEntries
        .filter(([, value]) => !isEncryptedQueryCacheValue(value))
        .map(async ([key, value]) => {
        try {
            await encryptAndSet(key, value, store, encryption);
        }
        catch {
            // encryptAndSet deletes values it cannot protect; continue migrating the rest.
        }
    }));
}
async function encryptAndSet(key, value, store, encryption) {
    try {
        const ciphertext = await encryption.encrypt(value);
        await set(key, { [ENCRYPTED_VALUE_MARKER]: ciphertext }, store);
    }
    catch (error) {
        await del(key, store);
        throw error;
    }
}
function indexedDbEncryptionBridge() {
    if (typeof window === 'undefined')
        return undefined;
    return window.__PERPLEXITY_ELECTRON_NATIVE__?.indexedDbEncryption;
}
function isEncryptedQueryCacheValue(value) {
    if (!value || typeof value !== 'object')
        return false;
    return (ENCRYPTED_VALUE_MARKER in value &&
        typeof value[ENCRYPTED_VALUE_MARKER] === 'string');
}
//# sourceMappingURL=encryptedQueryCache.js.map